<template>
  <div>
    <div
      class="login-form"
      v-loading.fullscreen.lock="configureLoading"
      :element-loading-text="LoadingText"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div>
        <div class="d-flex justify-between align-center mb-3 flex-wrap">
          <span class="register-heading" :style="getPrimaryColor">Create an Account!</span>
          <div class="nav-link text-right">
            Already have an account?&nbsp;
            <router-link to="/signin" class="fw-bold" :style="getPrimaryColor">Log In</router-link>
          </div>
        </div>
        <div class="divider">
          <span class="line"></span>
          <span class="line"></span>
        </div>
        <div class="content">
          <div>
            <el-form
              :model="signup"
              :rules="rules"
              ref="signup"
              class="log-form"
              @keyup.enter.native="submitForm('signup')"
            >
              <el-form-item label="Email" prop="email">
                <el-input
                  v-model="signup.email"
                  placeholder="Ex: johnwesley@abc.com"
                  autocomplete="off"
                  @blur="checkEmailAlreadyReg"
                ></el-input>
                <p class="error" v-if="getErrors && getErrors.email">
                  {{ getErrors.email }}
                </p>
                <p
                  class="error"
                  v-if="
                    getErrors &&
                    getErrors.critical_error &&
                    getErrors.critical_error == 'Account with this email is already taken'
                  "
                >
                  {{ getErrors.critical_error }}
                </p>
              </el-form-item>
              <div class="name-fields">
                <el-form-item label="First Name" prop="first_name">
                  <el-input
                    v-model="signup.first_name"
                    placeholder="Enter first name"
                    :readonly="isDisabled"
                    :disabled="isDisabled"
                  ></el-input>
                  <p class="error" v-if="getErrors && getErrors.first_name">
                    {{ getErrors.first_name }}
                  </p>
                </el-form-item>
                <el-form-item label="Last Name" prop="last_name">
                  <el-input
                    v-model="signup.last_name"
                    placeholder="Enter last name"
                    :readonly="isDisabled"
                    :disabled="isDisabled"
                  ></el-input>
                  <p class="error" v-if="getErrors && getErrors.last_name">
                    {{ getErrors.last_name }}
                  </p>
                </el-form-item>
              </div>
              <el-form-item label="Mobile" prop="phone">
                <el-input
                  v-model="signup.phone"
                  placeholder="989 989 9899"
                  pattern="^[+]?[0-9]+$"
                  autocomplete="off"
                  :readonly="isDisabled"
                  :disabled="isDisabled"
                  :class="{ 'has-error': !isValidPhone }"
                ></el-input>
                <p class="error" v-if="getErrors && getErrors.phone">
                  {{ getErrors.phone }}
                </p>
              </el-form-item>
              <el-form-item label="Choose an Account Type" prop="type">
                <br />
                <el-radio v-model="signup.accountType" label="INDIVIDUAL"></el-radio>
                <el-radio v-model="signup.accountType" label="BUSINESS"></el-radio>
              </el-form-item>
              <el-form-item
                v-if="signup.accountType == 'BUSINESS'"
                label="Company Name"
                prop="company_name"
              >
                <el-input v-model="signup.company_name" placeholder="Enter company name"></el-input>
                <p class="error" v-if="getErrors && getErrors.company_name">
                  {{ getErrors.company_name }}
                </p>
                <p class="error" v-if="errors && errors.company_name">
                  {{ errors.company_name }}
                </p>
              </el-form-item>
              <div class="name-fields">
                <el-form-item v-if="emailRegistred" prop="password" class="mr-1">
                  Password
                  <span class="text-danger">*</span>
                  <div class="password-input-wrapper">
                    <el-input
                      :type="passwordType"
                      placeholder="Enter Password"
                      v-model="signup.password"
                      autocomplete="off"
                      ref="passwordInput"
                      @input="checkPassword"
                    ></el-input>
                    <span
                      class="password-toggle"
                      :style="getPrimaryColor"
                      @click="passwordType = passwordType === 'password' ? 'text' : 'password'"
                    >
                      {{ passwordType === 'password' ? 'SHOW' : 'HIDE' }}
                    </span>
                  </div>
                  <p class="error" v-if="getErrors && getErrors.password">
                    {{ getErrors.password }}
                  </p>
                  <p class="error" v-if="errors && errors.password">
                    {{ errors.password }}
                  </p>
                </el-form-item>
                <el-form-item v-if="emailRegistred" prop="cPassword">
                  Confirm Password
                  <span class="text-danger">*</span>
                  <div class="password-input-wrapper">
                    <el-input
                      :type="cpasswordType"
                      placeholder="Enter Password"
                      v-model="signup.cPassword"
                      autocomplete="off"
                      ref="passwordInput"
                      @input="checkConfirmPassword"
                    ></el-input>
                    <span
                      class="password-toggle"
                      :style="getPrimaryColor"
                      @click="cpasswordType = cpasswordType === 'password' ? 'text' : 'password'"
                    >
                      {{ cpasswordType === 'password' ? 'SHOW' : 'HIDE' }}
                    </span>
                  </div>
                </el-form-item>
              </div>
              <span class="error" v-for="(err, index) in passwordError" :key="index">
                {{ err }}
                <br />
              </span>
              <el-form-item prop="terms_and_conditions">
                <el-checkbox
                  name="type"
                  v-model="signup.terms_and_conditions"
                  @change="handleTermsState"
                >
                  <div class="terms-wrap">
                    I agree to
                    <el-link type="primary" :underline="false" @click="displayTermsAndConditions">
                      Terms of Services
                    </el-link>
                    &
                    <el-link type="primary" :underline="false" @click="displayPrivacyPolicy">
                      Privacy Policy
                    </el-link>
                  </div>
                </el-checkbox>
                <p class="error" v-if="errors.terms_and_conditions">
                  You have to agree the terms and privacy condition.
                </p>
              </el-form-item>
              <el-form-item>
                <el-button
                  :disabled="!isValidPhone"
                  type="primary"
                  size="medium"
                  round
                  class="w-100 fs-6"
                  @click="submitForm('signup')"
                  :loading="submitLoading"
                  :style="getButtonStyles"
                >
                  Register Account
                </el-button>
                <p
                  class="error"
                  v-if="
                    getErrors &&
                    getErrors.critical_error &&
                    getErrors.critical_error != 'Account with this email is already taken'
                  "
                >
                  {{ getErrors.critical_error }}
                </p>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="terms_and_conditions_dialog"
      :title="isTermsConditionsActive ? 'Terms and Conditions' : 'Privacy Policy'"
      class="terms-conditions-dilalog-main"
      :before-close="resetTermsAndPrivacy"
    >
      <div>
        <div style="padding: 5px" v-if="isTermsConditionsActive">
          <termsAndConditionsTemplate />
        </div>
        <div style="padding: 5px" v-else>
          <privacyAndPolicyTemplate />
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import termsAndConditionsTemplate from '@/components/templates/termsAndConditionsTemplate.vue';
  import privacyAndPolicyTemplate from '@/components/templates/privacyAndPolicyTemplate.vue';
  import Swal from 'sweetalert2';
  import app from '../../../config/app';

  import CustomizationLayer from '@/mixins/CustomizationLayer';
  export default {
    name: 'SignUp',
    components: {
      termsAndConditionsTemplate,
      privacyAndPolicyTemplate,
    },
    data() {
      return {
        appName: app.appName,
        passwordError: [],
        submitLoading: false,
        passwordType: 'password',
        cpasswordType: 'password',
        isPrivacyPolicyActive: false,
        isValidPhone: true,
        terms_and_conditions_dialog: false,
        isTermsConditionsActive: false,
        configureLoading: false,
        LoadingText: 'Loading...',
        isDisabled: false,
        companyPattern:
          /^(?!.*[.&!@#()+-/_*]{2})([a-zA-Z0-9.,&!@#()+-/_*]+[^\s])*[a-zA-Z0-9.,&!@#()+-/_*]+$/,
        emailRegistred: true,
        signup: {
          first_name: '',
          last_name: '',
          company_name: '',
          email: '',
          password: '',
          phone: '',
          cPassword: '',
          accountType: 'INDIVIDUAL',
        },
        password_rules: [
          {
            message:
              'Must have one Uppercase(A-Z) letter,one lowercase(a-z) letter ,one number(0-9) and one symbol',
            regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/,
          },
        ],
        rules: {
          email: [
            {
              required: true,
              message: 'Email is required',
              trigger: 'blur',
            },
            {
              type: 'email',
              message: 'Invalid Email',
              trigger: 'blur',
            },
          ],
          password: [],
          cPassword: [],
          phone: [
            {
              required: true,
              message: 'Phone is required',
              trigger: 'blur',
            },
            {
              required: true,
              // pattern: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im,
              pattern: /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/,
              message: 'Invalid Phone Number',
            },
          ],
          first_name: [
            {
              required: true,
              message: 'First name is required',
              trigger: 'blur',
            },
          ],
          last_name: [
            {
              required: true,
              message: 'Last name is required',
              trigger: 'blur',
            },
          ],
          company_name: [
            {
              required: true,
              message: 'Company name is required',
              trigger: 'blur',
            },
          ],
        },
        errors: {},
      };
    },
    mounted() {
      this.$store.dispatch('auth/reset');
    },
    mixins: [CustomizationLayer],
    computed: {
      ...mapGetters('errors', ['getErrors']),
      ...mapGetters('auth', [
        'getAuthenticationStatus',
        'isSignupCompleted',
        'getAccountNotVerified',
        'getAccountNotVerifiedEmail',
        'getEmailExist',
        'getCompanyInfo',
        'getResendVerificationEmail',
      ]),
      plan_id() {
        return this.$route.query._p || ''; // Get `_p` from URL
      },
      source() {
        return this.$route.query._source || ''; // Get `_source` from URL
      },
      termsError() {
        return !this.signup.terms_and_conditions;
      },
    },
    created() {
      this.$store.commit('errors/setErrors', null, { root: true });
    },
    methods: {
      validatePhone() {
        // Use a regular expression to validate the phone number pattern
        const phonePattern = /^[+]?[0-9]+$/;
        this.isValidPhone = phonePattern.test(this.signup.phone);
      },
      submitForm(formName) {
        this.errors = {};

        if (this.emailRegistred) {
          this.checkPassword();
          if (!this.signup.cPassword.length && this.signup.password != this.signup.cPassword) {
            this.passwordError.push('Password miss match');
          }
        }
        this.$refs[formName].validate((valid, errors) => {
          if (valid) {
            if (this.passwordError.length) {
              return false;
            } else if (this.emailRegistred && this.errors && this.errors.password) {
              return false;
            }
            // else if (this.signup.accountType === "BUSINESS") {
            //   if (this.companyPattern.test(this.signup.company_name)) {
            //     this.errors.company_name = "Invalid Company Name";
            //     return false;
            //   }
            //   // /^[.@&]?[a-zA-Z0-9 ]+[ !.@&()]?[ a-zA-Z0-9!()]+/
            // }
            else if (!this.signup.terms_and_conditions) {
              {
                this.errors.terms_and_conditions = true;
                return false;
              }
            } else {
              this.signUp();
            }
          } else {
            console.log(errors);
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      resetTermsAndPrivacy() {
        this.isTermsConditionsActive = false;
        this.terms_and_conditions_dialog = false;
      },
      displayTermsAndConditions() {
        this.isTermsConditionsActive = true;
        this.terms_and_conditions_dialog = true;
      },
      displayPrivacyPolicy() {
        this.terms_and_conditions_dialog = true;
      },
      async signUp() {
        try {
          if (!this.signup.terms_and_conditions) {
            this.$message.error(`Please accept terms and conditions of ${this.appName}!`);
          } else {
            this.submitLoading = true;
            let data = {
              first_name: this.signup.first_name,
              last_name: this.signup.last_name,
              email: this.signup.email.toLowerCase(),
              password: this.signup.password,
              terms_and_conditions: this.signup.terms_and_conditions,
              phone: this.signup.phone,
              cPassword: this.signup.cPassword,
              plan_type: this.signup.accountType,
              plan_id: this.plan_id, // Use computed property
              source: this.source, // Use computed property
            };
            if (!this.emailRegistred) {
              delete data.password;
              delete data.cPassword;
            }
            if (this.signup.accountType == 'BUSINESS') {
              data['company'] = this.signup.company_name.trim();
            }
            await this.$store.dispatch('auth/companySignup', data);
            if (this.getAccountNotVerified) {
              this.$router.push('/send-verification?email=' + this.signup.email);
            } else if (this.isSignupCompleted) {
              let companyDetails = this.getCompanyInfo.data;
              if (this.getCompanyInfo.message == 'COMPANY_ON_HOLD') {
                this.$notify.success({
                  title: 'Success',
                  message: 'Company Name is already registered with the user and need verification',
                });
                this.$router.push(`/verify?email=${data.email}&company=${companyDetails._id}`);
              } else if (this.getCompanyInfo.message == 'COMPANY_ACTIVE') {
                this.$notify.success({
                  title: 'Success',
                  message: 'Company Name is already registered with the user',
                });
                this.$router.push('/signin');
              } else {
                this.$notify.success({
                  title: 'Success',
                  message: 'Registered Successfully',
                });
                if (companyDetails && companyDetails._id) {
                  this.$router.push(`/verify?email=${data.email}&company=${companyDetails._id}`);
                }
                if (!companyDetails) {
                  this.$router.push(`/verify?email=${data.email}`);
                }
              }
            }
            this.submitLoading = false;
          }
        } catch (err) {
          this.submitLoading = false;
          console.log('signUp', err);
        }
      },
      async checkEmailAlreadyReg() {
        if (this.signup.email) {
          this.configureLoading = true;
          this.LoadingText = 'Please wait, while we are validating your email address.';
          try {
            await this.$store.dispatch('auth/checkUserExist', this.signup.email);
            if (this.getEmailExist) {
              if (this.getEmailExist.status_code === 200 || this.getEmailExist.statusCode === 200) {
                setTimeout(() => {
                  this.LoadingText =
                    'Account already exist with this email. Please continue with existing account Password ';
                }, 2000);

                if (this.getEmailExist.message.email_confirmed) {
                  this.signup.first_name = this.getEmailExist.message.first_name;
                  this.signup.last_name = this.getEmailExist.message.last_name;
                  this.signup.phone = this.getEmailExist.message.phone;
                  this.signup.cPassword = '';
                  this.signup.password = '';
                  this.emailRegistred = false;
                  this.isDisabled = true;

                  this.$refs['signup'].validate((valid, errors) => {
                    if (valid) {
                      console.log(valid);
                    } else {
                      console.log(errors);
                    }
                  });
                  this.$store.commit('errors/setErrors', null, { root: true });
                  this.passwordError = [];
                  setTimeout(() => {
                    this.configureLoading = false;
                  }, 5000);
                } else {
                  setTimeout(() => {
                    this.configureLoading = false;
                    this.resendEmailVerification();
                  }, 2000);
                }
              } else {
                this.emailRegistred = true;

                setTimeout(() => {
                  this.configureLoading = false;
                  this.LoadingText = 'Loading ....';
                }, 3000);
                this.signup.first_name = '';
                this.signup.last_name = '';
                this.signup.phone = '';
                this.isDisabled = false;
              }
            }
          } catch (err) {
            this.submitLoading = false;
            this.configureLoading = false;
            this.LoadingText = 'Loading ....';
            console.log('checkEmailAlreadyReg', err);
          }
        }
      },

      async resendVerificationMail() {
        try {
          this.loading = true;
          await this.$store.dispatch('auth/resendInviteEmailToUser', {
            email: this.signup.email.toLowerCase(),
            // company: this.getErrorData,
          });

          if (this.getResendVerificationEmail) {
            this.$notify.success({
              title: 'Success',
              message: 'Verification mail sent to your email',
            });
            this.signup = {
              first_name: '',
              last_name: '',
              company_name: '',
              email: '',
              password: '',
              // terms_and_conditions: false,
              phone: '',
              cPassword: '',
              accountType: 'INDIVIDUAL',
            };
            this.$store.commit('errors/reset', null, { root: true });
            this.$store.commit('auth/setErrorCode', '', { root: true });
            this.$store.commit('auth/setErrorData', '', { root: true });
          }
          this.loading = false;
        } catch (err) {
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message: 'Error at sending verification mail',
          });
        }
      },

      handleTermsState() {
        this.errors.terms_and_conditions = this.signup.terms_and_conditions ? false : true;
      },
      checkPassword() {
        this.errors.password = '';
        this.passwordError = [];
        if (this.signup.password) {
          this.password_rules.forEach((rule) => {
            if (!rule.regex.test(this.signup.password)) {
              this.passwordError.push(rule.message);
            }
          });
          if (this.signup.password.length && this.signup.cPassword.length) {
            // this.checkConfirmPassword();
            if (this.signup.password != this.signup.cPassword) {
              this.passwordError.push('Password miss match');
            }
          }
        } else {
          {
            this.errors.password = 'Password is required';
          }
        }
      },
      checkConfirmPassword() {
        this.passwordError = [];
        // if (this.passwordError.length && this.signup.cPassword.length) {
        if (this.signup.password != this.signup.cPassword) {
          this.passwordError.push('Password miss match');
        } else {
          this.passwordError = [];
        }
      },
      async resendEmailVerification() {
        Swal.fire({
          icon: 'info',
          title: '',
          text: 'We noticed that you already have an account with us. Please verify your email and complete your profile',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          confirmButtonText: 'Verify Your Account',
        }).then((result) => {
          if (result.isConfirmed) {
            //api call

            Swal.close();
            let timerInterval;
            this.resendVerificationMail();
            Swal.fire({
              title: '',
              html: 'Please wait ..... ',
              timer: 2000,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              didOpen: () => {
                Swal.showLoading();
              },
              willClose: () => {
                clearInterval(timerInterval);
              },
            });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .swal2-icon {
    .swal2-info {
      border-color: #f754a2 !important;
      color: #f754a2 !important;
    }
  }

  .swal2-styled {
    .swal2-confirm {
      background-color: #f754a2 !important;
    }
  }

  .has-error {
    border-color: red;
  }

  a {
    text-decoration: none !important;
    color: #196392 !important;
  }

  a:hover {
    text-decoration: underline !important;
    /* Optional: underline on hover */
    color: #196392 !important;
  }

  .divider {
    display: flex;
    align-items: center;
    width: 100%;
    text-align: center;
    /* margin: 0 20px; */
  }

  .line {
    flex: 1;
    border-top: 1px solid #ddd;
    /* light gray line */
  }

  .password-input-wrapper {
    position: relative;
  }

  .password-toggle {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #409eff;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    user-select: none;
  }

  .login-form {
    border: 1px solid #cfcfcf;
    border-radius: 2em;
    width: 100%;
    max-width: 480px;
    padding: 2rem;
    /* border-radius: 8px; */
    background: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
  }

  .login-form h2 {
    margin-bottom: 1.5rem;
    color: #333;
    text-align: center;
  }

  .login-form input {
    width: 100%;
    padding: 0.75rem;
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
  }

  /* FULL RESPONSIVE FOR MOBILE & TABLET */
  @media (max-width: 1024px) {
    .login-form {
      border: 1px solid #cfcfcf;
      border-radius: 2em;
      // max-width: 100%;
      padding: 1.5rem;
      margin: 0 auto;
      box-shadow: none;
      /* border-radius: 0; */
    }

    .login-form h2 {
      font-size: 1.5rem;
    }

    .password-toggle {
      right: 10px;
      font-size: 12px;
    }
  }

  .el-form-item {
    margin-bottom: 8px !important;
  }

  .name-fields {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  @media (min-width: 768px) {
    .name-fields {
      flex-direction: row;
    }

    .name-fields .el-form-item {
      flex: 1;
    }

    .name-fields .el-form-item:first-child {
      margin-right: 10px;
    }
  }

  .terms-wrap {
    display: inline-block;
    white-space: normal;
    word-break: break-word;
    max-width: 100%;
  }

  .d-flex {
    display: flex;
  }

  .justify-between {
    justify-content: space-between;
  }

  .align-center {
    align-items: center;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .mb-3 {
    margin-bottom: 1rem;
  }

  .m-0 {
    margin: 0;
  }

  .register-heading {
    font-size: 1.25rem;
    font-weight: 600;
    color: #196392;
    padding-bottom: 0.5rem;
    margin: 0;
    display: inline-block;
  }
</style>
